export function isValidEmail(email : string): boolean {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]{1,63}\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}
